import { useResourceSelectionStore } from '../stores/resourceSelectionStore';

/**
 * Select-all / deselect-all icon button pair — the React port of resource_filter.html's
 * uib-btn-radio group. Left button selects every matching resource (mode 'all'); right
 * button (check-double + slash) clears the selection (mode 'none'). Neither is active in
 * a partial 'some' selection. The selection count lives on the Add Tag badge, as in Angular.
 */
export function SelectAllButtons() {
  const mode = useResourceSelectionStore((s) => s.mode);
  const selectAllMatching = useResourceSelectionStore((s) => s.selectAllMatching);
  const clear = useResourceSelectionStore((s) => s.clear);

  return (
    <div className="btn-group" role="group">
      <button
        type="button"
        className={`btn btn-default${mode === 'all' ? ' active' : ''}`}
        onClick={() => selectAllMatching()}
        title="Select All Resources"
        aria-pressed={mode === 'all'}
      >
        <i className="fas fa-check-double fa-fw" aria-hidden="true" />
      </button>
      <button
        type="button"
        className={`btn btn-default${mode === 'none' ? ' active' : ''}`}
        onClick={() => clear()}
        title="Deselect All Resources"
        aria-pressed={mode === 'none'}
      >
        <span className="fa-stack fa-fw" style={{ fontSize: 8 }}>
          <i className="fas fa-check-double fa-stack-2x" style={{ fontSize: 'small' }} aria-hidden="true" />
          <i className="fas fa-slash fa-stack-2x" style={{ fontSize: 'small' }} aria-hidden="true" />
        </span>
      </button>
    </div>
  );
}
